var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list"},[_c('ul',{staticClass:"round",domProps:{"innerHTML":_vm._s(_vm.convertToList(_vm.items))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }